export default __webpack_public_path__ + "static/media/resume-why-company.f917403c.png";